/**
 * Email-code sign-in on authProxy's web routes (T-330 batch 8b). It runs before any token
 * exists, so callAuth sends no Authorization header. A refusal keeps the server's code
 * (`functions/<code>`), which picks the message.
 */

import { callAuth } from "./appProxy";
import { callableErrorCode } from "./invite";

export async function requestLoginCode(email: string): Promise<void> {
  const data = await callAuth<{ success: boolean }>("POST", "/web-request-code", { email });
  if (!data.success) throw new Error("Failed to send code");
}

/** The custom token that signs the web in. */
export async function verifyLoginCode(email: string, code: string): Promise<string> {
  const data = await callAuth<{ success: boolean; token?: string }>("POST", "/web-verify-code", { email, code });
  if (!data.success || !data.token) throw new Error("Failed to verify code");
  return data.token;
}

export const requestCodeErrorKey = (err: unknown, resend = false): string =>
  callableErrorCode(err) === "resource-exhausted"
    ? "login.errors.waitBeforeResend"
    : resend ? "login.errors.resendFailed" : "login.errors.sendFailed";

const VERIFY_ERROR_KEYS: Record<string, string> = {
  "not-found": "login.errors.codeExpired",
  "deadline-exceeded": "login.errors.codeExpired",
  "permission-denied": "login.errors.invalidCode",
  "resource-exhausted": "login.errors.tooManyAttempts",
};

export const verifyCodeErrorKey = (err: unknown): string =>
  VERIFY_ERROR_KEYS[callableErrorCode(err)] ?? "login.errors.verifyFailed";
